export default __webpack_public_path__ + "static/media/video-pomelo-hat2.bc18857c.mp4";